import { useRef } from "react";
import { trendingItems } from "@/mocks/categories";

export default function TrendingGrid() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      const amount = 300;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -amount : amount,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="relative w-full bg-background-100 py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 text-center mb-10 md:mb-12">
          Trending This Week
        </h2>
      </div>

      <div className="relative">
        <button
          onClick={() => scroll("left")}
          className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 z-10 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/90 text-foreground-700 hover:text-foreground-950 transition-all duration-200 cursor-pointer"
          aria-label="Scroll left"
        >
          <i className="ri-arrow-left-s-line text-lg"></i>
        </button>

        <div
          ref={scrollRef}
          className="flex gap-4 md:gap-5 overflow-x-auto px-4 md:px-6 pb-4"
          style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        >
          {trendingItems.map((item) => (
            <a
              key={item.imageUrl}
              href={item.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-[200px] md:w-[240px] group cursor-pointer"
            >
              <div className="rounded-lg overflow-hidden bg-background-50 aspect-square relative">
                {item.hot && (
                  <span className="absolute top-3 left-3 z-10 px-2 py-0.5 text-[10px] font-bold whitespace-nowrap rounded-full bg-accent-500 text-white">
                    HOT
                  </span>
                )}
                <img
                  src={item.imageUrl}
                  alt={"Pandabuy Spreadsheet " + item.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="mt-3 text-center">
                <p className="text-sm font-semibold text-foreground-900">{item.name}</p>
                <p className="text-xs text-foreground-500 mt-0.5">{item.price}</p>
              </div>
            </a>
          ))}
        </div>

        <button
          onClick={() => scroll("right")}
          className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 z-10 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/90 text-foreground-700 hover:text-foreground-950 transition-all duration-200 cursor-pointer"
          aria-label="Scroll right"
        >
          <i className="ri-arrow-right-s-line text-lg"></i>
        </button>
      </div>
    </section>
  );
}